<template>
  <section class="wrapper-fellings">
    <div
      v-if="!getChartsOrderByChannel.length"
      class="wrapper-fellings__instagram-message"
    >
      <p>{{ getMessage.title }}</p>
      <p>{{ getMessage.description }}</p>
    </div>

    <div
      v-for="(chart, index) in getChartsOrderByChannel"
      v-else
      :key="index"
    >
      <component :is="chart.component" />
    </div>
  </section>
</template>

<script>
import { SentimentsInTheCommentsOverTime } from '@/components/content/SentimentsInTheCommentsOverTime';
import { SentimentsInTheComments } from '@/components/content/SentimentsInTheComments';
import { TermsMentioned } from '@/components/content/TermsMentioned';

export default {
  name: 'SectionSentiments',
  components: {
    SentimentsInTheCommentsOverTime,
    SentimentsInTheComments,
    TermsMentioned,
  },
  data() {
    return {
      title: '',
      description: '',
    };
  },
  computed: {
    getChartsOrderByChannel() {
      const channel = this.$store.state.ui.channel.toLowerCase();

      if (['instagram', 'todas'].includes(channel)) return [];

      const componentOrdersByChannel = {
        SentimentsInTheComments: {
          todas: undefined,
          instagram: undefined,
          facebook: 1,
          twitter: 1,
          youtube: 1,
        },
        SentimentsInTheCommentsOverTime: {
          todas: undefined,
          instagram: undefined,
          facebook: 2,
          twitter: 2,
          youtube: 2,
        },
        TermsMentioned: {
          todas: undefined,
          instagram: undefined,
          facebook: 3,
          twitter: 3,
          youtube: 3,
        },
      };

      return Object.keys(componentOrdersByChannel)
        .map(component => {
          const ordersByChannel = componentOrdersByChannel[component];
          const getOrder = channel in ordersByChannel ? ordersByChannel[channel] : ordersByChannel.todas;

          return {
            order: getOrder,
            component,
          };
        })
        .filter(r => r.order)
        .sort((a, b) => a.order - b.order);
    },
    getMessage() {
      const channel = this.$store.state.ui.channel.toLowerCase();

      const message = {
        todas: {
          title: 'Ainda não temos dados disponíveis para "Todas as redes"',
          description: 'Enquanto isso, você pode visualizar nas redes sociais: Facebook, Twitter e Youtube.',
        },
        instagram: {
          title: 'Não há dados de sentimentos para Instagram',
          description: 'Os dados dos comentários não são disponibilizados pela API pública da rede social.',
        },
      };

      return message[channel];
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper-fellings {
  & > div:not(:first-child) {
    margin-top: var(--ds-spacing-stack-md);
  }

  &__instagram-message {
    padding-top: 100px;

    :first-child {
      color: var(--ds-color-text-1);
      font-weight: var(--ds-font-weight-semibold);
    }

    p {
      text-align: center;
    }
  }
}
</style>
